/**
 * operation.js
 *
 * @description Describes various operations in the entitlements system.
 */

export const Operation = {
  ADMINISTER_USER_PIN: 'administer_user_pin',
  ADD: 'add',
  CONFIGURE: 'configure',
  CREATE: 'create',
  DELETE: 'delete',
  DIAGNOSTIC_EXPORT: 'diagnostic_export',
  EDIT: 'edit',
  FIND_ALL: 'find_all',
  FEATURE_FLAGS: 'feature_flags',
  FIND_RESIDENT: 'find_resident',
  LIMITED_EDIT: 'limited_edit',
  MANAGE_MODEL: 'manage_model',
  MERGE: 'merge',
  PIN_DISMISS_ALERT: 'pin_dismiss_alert',
  RECEIVE_ER_ALERTS: 'receive_er_alerts',
  RECEIVE_LIVE: 'receive_live',
  SET_DISMISS_PIN: 'set_dismiss_pin',
  SNOOZE: 'snooze',
  TRAIN_MODEL: 'train_model',
  VIEW_ALL: 'view_all',
  VIEW_ENV_INFO: 'view_env_info',
  VIEW_EXPANDED_HISTOGRAM: 'view_expanded_histogram',
  VIEW_F1_SCORE: 'view_f1_score',
  VIEW_GIT_INFO: 'view_git_info',
  VIEW_HISTORIC: 'view_historic',
  VIEW_INTERNAL_LINKS: 'view_internal_links',
  VIEW_LIVE: 'view_live',
  VIEW_TRAINING_PROGRESS: 'view_training_progress',
  VIEW_REPORTS: 'view_reports',
  VIEW_REALTIME: 'view_realtime',
}
